import { Component, AfterViewInit, OnDestroy } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { PopinComponentBase } from '@ui/misc/popin-modal/popin-component-base';
import { IAuroraState } from '@apps/aurora.state';
import * as fromBackStore from '@apps/back/store';
import * as fromAuthStore from '@apps/auth/store';
import { ImpersonateService } from '@apps/root/services/impersonate.service';
import { BackAuthEntitySelectedReset } from '@apps/back/store/auth/entities/global/entities-global.actions';
import { BackAuthUserSelectedReset } from '@apps/back/store/auth/users/global/users-global.actions';
import { DetailedUser } from '@apps/back/store/auth/users/users.common';

@Component({
    selector: 'aa-impersonate',
    templateUrl: './impersonate.component.html',
    styleUrls: [
        './impersonate.component.scss'
    ],
    standalone: false
})
export class ImpersonateComponent extends PopinComponentBase implements AfterViewInit, OnDestroy
{
    public isShown: boolean = false;
    public disabled: Observable<boolean> = of(true);
    private destroyator = new Subject();

    constructor (
        private store: Store<IAuroraState>,
        private impersonateService: ImpersonateService
    )
    {
        super(null);

        this.disabled = this.store.select(fromBackStore.getSelectedUser)
            .pipe(
                map(user => user === null)
            );
    }

    ngAfterViewInit (): void
    {
        Promise.resolve(null).then(() => this.isShown = true);
    }

    ngOnDestroy (): void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    impersonate = () =>
    {
        this.store
            .pipe(
                select(fromBackStore.getSelectedUser),
                filter(detailedUser => detailedUser !== null),
                tap((detailedUser: DetailedUser) =>
                {
                    this.impersonateService.setImpersonation(detailedUser);
                    this.store.dispatch(
                        fromAuthStore.AuthProfileStoreActions.AuthProfileApplicationRolesSet({ appRoles: detailedUser.appRoles })
                    );
                }),
                take(1)
            )
            .subscribe();

        this.close();
    };

    quit = () =>
    {
        this.resetImpersonate();

        this.close();
    };

    onClosePopin = (): void =>
    {
        this.close();
    };

    private resetImpersonate ()
    {
        this.store.dispatch(
            BackAuthEntitySelectedReset()
        );
        this.store.dispatch(
            BackAuthUserSelectedReset()
        );
        this.store.dispatch(
            fromAuthStore.AuthProfileStoreActions.AuthProfileApplicationRolesReset()
        );
        this.impersonateService.unsetImpersonation();
    }

    private close ()
    {
        this.isShown = false;
    }
}
